export default __webpack_public_path__ + "static/media/xpel_ultimate_plus.35b26fe7.jpg";